/** Plein écran d'un planning (atelier, réception).
 *
 *  Shared so the two plannings keep the same button, the same icons and the same
 *  Échap hint — they sit side by side in the app and a divergence shows immediately.
 *  The screen owns the state: it alone knows what chrome to hide. */
export default function FullscreenToggle({
  fullscreen,
  onToggle,
}: {
  fullscreen: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      onClick={onToggle}
      title={fullscreen ? "Quitter le plein écran (Échap)" : "Plein écran"}
      className="flex items-center justify-center w-9 h-9 rounded-lg border border-neutral-200 bg-white text-neutral-500 hover:text-neutral-900 hover:bg-neutral-50 transition-colors flex-shrink-0"
    >
      {fullscreen ? (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M7 2v3.5A1.5 1.5 0 0 1 5.5 7H2M16 7h-3.5A1.5 1.5 0 0 1 11 5.5V2M11 16v-3.5a1.5 1.5 0 0 1 1.5-1.5H16M2 11h3.5A1.5 1.5 0 0 1 7 12.5V16"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M2 6.5V3a1 1 0 0 1 1-1h3.5M16 6.5V3a1 1 0 0 0-1-1h-3.5M2 11.5V15a1 1 0 0 0 1 1h3.5M16 11.5V15a1 1 0 0 1-1 1h-3.5"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
  );
}
